import { useState } from 'react';

export function About({ onClose }) {
  const version = '1.0.1';
  const buildDate = __BUILD_DATE__;
  const [updating, setUpdating] = useState(false);
  const [updateStatus, setUpdateStatus] = useState('');

  const checkForUpdates = async () => {
    setUpdating(true);
    setUpdateStatus('Controleren op updates...');

    try {
      if ('serviceWorker' in navigator) {
        const registrations = await navigator.serviceWorker.getRegistrations();
        for (const registration of registrations) {
          await registration.unregister();
        }
      }

      if ('caches' in window) {
        const cacheNames = await caches.keys();
        await Promise.all(cacheNames.map(name => caches.delete(name)));
      }

      setUpdateStatus('Update gevonden! Herladen...');
      setTimeout(() => {
        window.location.reload(true);
      }, 1000);
    } catch (error) {
      setUpdateStatus('Fout bij updaten: ' + error.message);
      setUpdating(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" onClick={onClose}>
      <div className="bg-white rounded-lg p-6 max-w-md mx-4" onClick={(e) => e.stopPropagation()}>
        <h2 className="text-2xl font-bold mb-4">HavunCore Dashboard</h2>

        <div className="space-y-3 text-sm">
          <div>
            <div className="font-semibold text-gray-700">Versie</div>
            <div className="text-gray-600">{version}</div>
          </div>

          <div>
            <div className="font-semibold text-gray-700">Build Datum</div>
            <div className="text-gray-600">{buildDate}</div>
          </div>

          <div>
            <div className="font-semibold text-gray-700">Status</div>
            <div className="text-gray-600">
              {navigator.onLine ? '🟢 Online' : '🔴 Offline'}
            </div>
          </div>

          <div className="pt-4 border-t space-y-2">
            <button
              onClick={checkForUpdates}
              disabled={updating}
              className="w-full bg-blue-500 text-white py-3 rounded-lg hover:bg-blue-600 active:bg-blue-700 disabled:bg-blue-300 font-medium"
            >
              {updating ? '⏳ Bezig...' : '🔄 Check voor Updates'}
            </button>

            {updateStatus && (
              <div className="text-center text-sm text-gray-600 py-2">
                {updateStatus}
              </div>
            )}
          </div>
        </div>

        <button
          onClick={onClose}
          className="mt-4 w-full bg-gray-200 text-gray-800 py-2 rounded-sm hover:bg-gray-300 active:bg-gray-400"
        >
          Sluiten
        </button>
      </div>
    </div>
  );
}
